import { render, staticRenderFns } from "./CompanyInventoryPage.vue?vue&type=template&id=937d5e52&scoped=true&"
import script from "./CompanyInventoryPage.vue?vue&type=script&lang=js&"
export * from "./CompanyInventoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937d5e52",
  null
  
)

export default component.exports